/**
 * External dependencies
 */
import React, { useState, useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Row, Col } from "react-bootstrap"
import { orderBy } from "lodash"
import { Link } from "gatsby"
import classNames from "classnames"
import axios from "axios";
import { navigate } from "@reach/router"
import algoliasearch from "algoliasearch/lite";
/**
 * Internal dependencies
 */
import Qrcode from '../../images/gps5dq3c.png'
import { useQuery } from "@apollo/client"
import gql from "graphql-tag"
import { toCapitalize } from "@components/common/utils";
import Button from "../button/button"
import LinkIcon from "../link-icon/link-icon"
import "./styles/_index.scss"
import Modal from 'react-bootstrap/Modal';
import BookAViewingForm from "../../Forms/BookAViewing"
import ImageTransform from "@components/common/ggfx-client/module/components/image-transform";
import {
  OFFICE_PAGE_URL
} from "@components/common/site/constants"

/**
 * Constants
 */
const CACHE_KEY = "total_auction_data";
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const AuctionCallout = (props) => {
  const [showForm, setShowForm] = useState(false);
  const [nextLot, setNextLot] = useState("");
  const [previousLot, setPreviousLot] = useState("");
  const [propList, setPropList] = useState([]);

  const openform = () => {
    setShowForm(!showForm)
  }

  const navigateLot = (slug) => {
    navigate(`/auction-property-for-sale/${slug}`)
  }

  const shareurl = typeof window !== 'undefined' ? window.location.href : ''
  const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

  const GET_OFFICE_DETAIL = gql`
  query GetOfficeDetail($URL: String!) {
    offices(where: { URL: $URL }) {
      id
      imagetransforms
      Office_Name
      Tail_Image {
        url
        alternativeText
      }
      Office_Address
      Office_Email
      URL
      Office_Telephone_Sales
      Office_Telephone_Lettings
      Office_Telephone_Progression
     
    }
  }
`

  const { loading, error, data } = useQuery(GET_OFFICE_DETAIL, {
    variables: { URL: "auctions-office" },
  })


  let processedImages = JSON.stringify({});
  if (data?.offices?.length > 0 && data?.offices[0]?.imagetransforms?.Tail_Image_Transforms) {
    processedImages = data?.offices[0]?.imagetransforms?.Tail_Image_Transforms;
  }

  // LOCAL STORAGE HELPERS
  const readCache = () => {
    if (typeof window === "undefined") return null;

    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;

      const cache = JSON.parse(raw);

      if (!cache.expTime || Date.now() > cache.expTime) {
        localStorage.removeItem(CACHE_KEY);
        return null;
      }

      return Array.isArray(cache.hits) ? cache.hits : null;
    } catch {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }
  };

  const writeCache = (hits) => {
    if (typeof window === "undefined") return;

    const expTime = Date.now() + CACHE_TTL;
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ hits, expTime })
    );
  };

  // LOAD AUCTION ITEMS
  const getItems = async () => {
    // Try cache
    const cachedHits = readCache();
    if (cachedHits?.length) {
      setPropList(orderBy(cachedHits, ["lotNumber"], ["asc"]));
      return;
    }

    // Fetch from Algolia
    if (typeof window === "undefined") return;

    const filterArray = localStorage.getItem("filterArray")
      ? JSON.parse(localStorage.getItem("filterArray"))
      : {};

    const client = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
    );

    const index = client.initIndex(
      filterArray?.page_url_data?.sortVal ||
        process.env.GATSBY_ALGOLIA_INDEX_NAME
    );

    const { hits } = await index.search(
      filterArray?.area_name_length === 1 &&
        filterArray?.area_name &&
        filterArray?.area_name !== true
        ? filterArray.area_name
        : "",
      {
        filters: filterArray?.myalgoliafilters,
        page: 0,
        hitsPerPage: 2000,
      }
    );

    const sortedHits = orderBy(hits, ["lotNumber"], ["asc"]);

    writeCache(sortedHits);
    setPropList(sortedHits);
  };

  // FETCH ON MOUNT
  useEffect(() => {
    getItems();
  }, []);

  // NEXT / PREVIOUS LOT LOGIC
  useEffect(() => {
    if (!propList.length || !props?.data?.id) return;

    const currentIndex = propList.findIndex(
      (item) =>
        String(item.objectID) === String(props.data.id)
    );

    if (currentIndex === -1) return;

    const prevIndex =
      currentIndex === 0
        ? propList.length - 1
        : currentIndex - 1;

    const nextIndex =
      currentIndex === propList.length - 1
        ? 0
        : currentIndex + 1;

    setPreviousLot(
      `${propList[prevIndex].slug}-${propList[prevIndex].objectID}`
    );

    setNextLot(
      `${propList[nextIndex].slug}-${propList[nextIndex].objectID}`
    );
  }, [propList, props?.data?.id]);

  return (
    props.data?.status !== "any" ?
      <div className="property-callout pt-32 pb-lg-32 pb-0">
        <div className="property-callout__head d-flex flex-column pb-1">
          <div className="property-callout__actions d-none d-lg-block">
            <h4 className="d-none d-lg-block text-center">interested?</h4>
            <div className={"property-callout__actions d-none d-lg-block"}>
              {props?.data?.extra?.legalDocumentUrl &&
                <Button isExternalLink={true} color="yellow" link={props?.data?.extra?.legalDocumentUrl}>
                  <Button.Icon>
                    <i className="icon icon--file"></i>
                  </Button.Icon>

                  <Button.Text>Legal Docs</Button.Text>
                </Button>
              }

              {data?.offices?.length > 0 && data?.offices[0] || props?.data?.extra?.contacts?.length > 0 ?
                <Button tel={data?.offices[0]?.Office_Telephone_Sales ? data?.offices[0]?.Office_Telephone_Sales : props?.data?.extra?.contacts?.length > 0 ? props?.data?.extra?.contacts[0]?.Telephone : ""}>
                  <Button.Icon>
                    <i className="icon icon--phone"></i>
                  </Button.Icon>

                  <Button.Text>{data?.offices[0]?.Office_Telephone_Sales ? data?.offices[0]?.Office_Telephone_Sales : props?.data?.extra?.contacts?.length > 0 ? props?.data?.extra?.contacts[0]?.Telephone : ""}</Button.Text>
                </Button>
                : null}
              {props?.data?.department === "auction" &&
                <>{nextLot &&
                  <Button displayAsLink={false} color="yellow" onClick={() => { navigateLot(nextLot) }}>
                    <Button.Text >Next Lot</Button.Text>
                  </Button>}
                  {previousLot &&
                    <Button displayAsLink={false} onClick={() => { navigateLot(previousLot) }}>
                      <Button.Text>Previous Lot</Button.Text>
                    </Button>}
                </>
              }

            </div>
          </div>
          {props?.data?.department === "auction" &&
            <div className="property-callout__actions d-block d-lg-none">
              <div className={"property-callout__actions d-flex d-lg-none mobile"}>
                {previousLot && <Button displayAsLink={false} onClick={() => { navigateLot(previousLot) }}>
                  <Button.Text>Previous Lot</Button.Text>
                </Button>}
                {nextLot &&
                  <Button displayAsLink={false} color="yellow" onClick={() => { navigateLot(nextLot) }}>
                    <Button.Text >Next Lot</Button.Text>
                  </Button>}

              </div>
            </div>
          }

          <>
            {data?.offices?.length > 0 && data?.offices[0] &&
              <>
                <Row className="property-callout__branch g-0">
                  {data?.offices[0]?.Tail_Image?.url &&
                    <Col xs="auto" className="property-callout__image-wrapper">
                      {/* {data.image && (
                <GatsbyImage image={data.image} alt="property callout" />
              )} */}
                      <ImageTransform
                        imagesources={data?.offices[0]?.Tail_Image?.url}
                        // renderer="srcSet"
                        imagename="office.Tail_Image.plist"
                        attr={{ alt: `${data?.offices[0]?.Office_Name} - Strakers Estate Agents`, className: "" }}
                        imagetransformresult={processedImages}
                        id={data?.offices[0]?.id}
                      />
                    </Col>
                  }
                  {data?.offices?.length > 0 && data?.offices[0] &&
                    <Col className="property-callout__content">
                      <h5>{toCapitalize(data?.offices[0]?.Office_Name)}</h5>
                      <p>{data?.offices[0]?.Office_Address ? data?.offices[0]?.Office_Address : props?.data?.extra?.contacts?.length > 0 ? props?.data?.extra?.contacts[0]?.FullAddress : ""}</p>

                      {/* <LinkIcon text="Contact Branch" order="1" /> */}
                      <Link class="link-icon blue-link-hover d-flex align-items-center"
                        to={OFFICE_PAGE_URL.alias + '/' + data?.offices[0]?.URL}
                      >
                        <div className={`link-icon__text fw-bolder fz14 position-relative order-1`}>Contact Branch</div>
                        <i className={classNames(`icon icon--arrow-up-right`)}></i>
                      </Link>
                    </Col>
                  }
                </Row>
                <Row className="property-callout__booking mt-1 pt-1 mb-1 pb-1">
                  <Col className="property-callout__content">
                    <h5>If you require auction finance advice, please scan the QR code.</h5>
                    <p className="text-align:center;">
                      <a href="https://landing.propertycircle.uk/gps5dq3c">
                        <img src={Qrcode} alt="QR Code for Auction Finance" width={"50%"} />
                      </a>
                    </p>
                  </Col>

                </Row>
              </>
            }
          </>


        </div>


        <div className="property-callout__booking mt-1 pt-1 ">
          <h3>valuation</h3>
          <p>
            Do you have a property you&apos;d like to Sell or Let with
            Strakers?
          </p>

          <Button href={"property-valuation-in-wiltshire"} color="outline">
            <Button.Text>Book a Valuation</Button.Text>
          </Button>
        </div>

        <Modal className="teamdetails popupForm" backdrop="static" size="lg" show={showForm} onHide={() => { setShowForm(false) }}>
          <Modal.Header closeButton>
            <Modal.Title> <div className="form__head">
              <h4>Book A Viewing</h4>
            </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BookAViewingForm
              to_admin={data?.offices[0]?.Office_Email?.toLowerCase()}
              id={props.data?.id}
              property_img={props.data?.images[0]?.url}
              page_url={shareurl}
              property_title={props.data?.display_address}
              type={props.data?.search_type}
              data={props?.data} />
          </Modal.Body>

        </Modal>
      </div>
      : null)
}
export default AuctionCallout
